// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#market-cap .header[data-v-6bd785a8] {
  margin-top: 13px;
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-family: "Avenir Next LT W01 Demi", Arial;
}
#market-cap .header.individual-style[data-v-6bd785a8] {
  color: #333;
  font-family: "AvenirNextLTW01-Regular", Arial;
  font-size: 26px;
}
#market-cap .data-list[data-v-6bd785a8] {
  display: flex;
  margin-bottom: 20px;
}
#market-cap .data-list .list-item[data-v-6bd785a8] {
  flex: 1;
}
#market-cap .data-list .list-item .percentage[data-v-6bd785a8] {
  font-size: 18px;
  font-family: "AvenirNextLTW01-Regular", Arial;
  line-height: 1.3em;
  color: #333;
}
#market-cap .data-list .list-item .list-label[data-v-6bd785a8] {
  font-size: 12px;
  color: #666;
  font-family: "AvenirNextLTW01-Regular", Arial;
}
#market-cap .data-list .weighted-average[data-v-6bd785a8] {
  border-left: 1px solid #CCCCCC;
  padding: 0 30px;
}
#market-cap .data-list .weighted-average div[data-v-6bd785a8] {
  min-width: max-content;
}
#market-cap .data-list .weighted-average div.value[data-v-6bd785a8] {
  font-size: 18px;
  font-family: "AvenirNextLTW01-Regular", Arial;
  line-height: 1.3em;
  font-weight: 400;
  color: #333;
}
#market-cap .data-list .weighted-average div.list-label[data-v-6bd785a8] {
  font-size: 12px;
  color: #666;
  font-weight: 400;
  font-family: "AvenirNextLTW01-Regular", Arial;
}
#market-cap .as-of-date[data-v-6bd785a8] {
  font-size: 12px;
  font-family: "AvenirNextLTW01-Condens 721299", Arial;
  color: #666;
  margin-bottom: 30px;
}
@media (max-width: 480px) {
#market-cap .data-list[data-v-6bd785a8] {
    flex-wrap: wrap;
}
#market-cap .data-list .list-item[data-v-6bd785a8] {
    flex: none;
    min-width: 90px;
    width: 25%;
}
#market-cap .data-list .weighted-average[data-v-6bd785a8] {
    width: 100%;
    margin-top: 10px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/MarketCapitalization.vue","webpack://./MarketCapitalization.vue"],"names":[],"mappings":"AACA;EAEE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,6CAAA;ACDF;ADEE;EACC,WAAA;EACA,6CAAA;EACA,eAAA;ACAH;ADVA;EAcE,aAAA;EACA,mBAAA;ACDF;ADdA;EAiBG,OAAA;ACAH;ADjBA;EAmBI,eAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;ACCJ;ADvBA;EAyBI,eAAA;EACA,WAAA;EACA,6CAAA;ACCJ;AD5BA;EA+BG,8BAAA;EACA,eAAA;ACAH;ADhCA;EAkCI,sBAAA;ACCJ;ADAI;EACC,eAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;ACEL;ADAI;EACC,eAAA;EACA,WAAA;EACA,gBAAA;EACA,6CAAA;ACEL;ADhDA;EAoDE,eAAA;EACA,oDAAA;EACA,WAAA;EACA,mBAAA;ACDF;ADIA;AACC;IAEE,eAAA;ACHD;ADCD;IAIG,UAAA;IACA,eAAA;IACA,UAAA;ACFF;ADJD;IASG,WAAA;IACA,gBAAA;ACFF;AACF","sourcesContent":["\n#market-cap {\n\t.header {\n\t\tmargin-top: 13px;\n\t\tmargin-bottom: 20px;\n\t\tfont-size: 18px;\n\t\tcolor: #333;\n\t\tfont-family: \"Avenir Next LT W01 Demi\",Arial;\n\t\t&.individual-style {\n\t\t\tcolor: #333;\n\t\t\tfont-family: \"AvenirNextLTW01-Regular\",Arial;\n\t\t\tfont-size: 26px;\n\t\t}\n\t}\n\t.data-list {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 20px;\n\t\t.list-item {\n\t\t\tflex: 1;\n\t\t\t.percentage {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tfont-family: \"AvenirNextLTW01-Regular\",Arial;\n\t\t\t\tline-height: 1.3em;\n\t\t\t\tcolor: #333;\n\t\t\t}\n\t\t\t.list-label {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tcolor: #666;\n\t\t\t\tfont-family: \"AvenirNextLTW01-Regular\",Arial;\n\t\t\t}\n\t\t}\n\t\t.weighted-average {\n\t\t\tborder-left: 1px solid #CCCCCC;\n\t\t\tpadding: 0 30px;\n\t\t\tdiv {\n\t\t\t\tmin-width: max-content;\n\t\t\t\t&.value {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tfont-family: \"AvenirNextLTW01-Regular\",Arial;\n\t\t\t\t\tline-height: 1.3em;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tcolor: #333;\n\t\t\t\t}\n\t\t\t\t&.list-label{\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tcolor: #666;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-family: \"AvenirNextLTW01-Regular\",Arial;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.as-of-date {\n\t\tfont-size: 12px;\n\t\tfont-family: \"AvenirNextLTW01-Condens 721299\",Arial;\n\t\tcolor: #666;\n\t\tmargin-bottom: 30px;\n\t}\n}\n@media (max-width: 480px) {\n\t#market-cap {\n\t\t.data-list {\n\t\t\tflex-wrap: wrap;\n\t\t\t.list-item {\n\t\t\t\tflex: none;\n\t\t\t\tmin-width: 90px;\n\t\t\t\twidth: 25%;\n\t\t\t}\n\t\t\t.weighted-average {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-top: 10px;\n\t\t\t}\n\t\t}\n\t}\n}\n","#market-cap .header {\n  margin-top: 13px;\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #333;\n  font-family: \"Avenir Next LT W01 Demi\", Arial;\n}\n#market-cap .header.individual-style {\n  color: #333;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  font-size: 26px;\n}\n#market-cap .data-list {\n  display: flex;\n  margin-bottom: 20px;\n}\n#market-cap .data-list .list-item {\n  flex: 1;\n}\n#market-cap .data-list .list-item .percentage {\n  font-size: 18px;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  line-height: 1.3em;\n  color: #333;\n}\n#market-cap .data-list .list-item .list-label {\n  font-size: 12px;\n  color: #666;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n}\n#market-cap .data-list .weighted-average {\n  border-left: 1px solid #CCCCCC;\n  padding: 0 30px;\n}\n#market-cap .data-list .weighted-average div {\n  min-width: max-content;\n}\n#market-cap .data-list .weighted-average div.value {\n  font-size: 18px;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  line-height: 1.3em;\n  font-weight: 400;\n  color: #333;\n}\n#market-cap .data-list .weighted-average div.list-label {\n  font-size: 12px;\n  color: #666;\n  font-weight: 400;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n}\n#market-cap .as-of-date {\n  font-size: 12px;\n  font-family: \"AvenirNextLTW01-Condens 721299\", Arial;\n  color: #666;\n  margin-bottom: 30px;\n}\n@media (max-width: 480px) {\n  #market-cap .data-list {\n    flex-wrap: wrap;\n  }\n  #market-cap .data-list .list-item {\n    flex: none;\n    min-width: 90px;\n    width: 25%;\n  }\n  #market-cap .data-list .weighted-average {\n    width: 100%;\n    margin-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
